import { createFileRoute } from "@tanstack/react-router"
import { Text, Stepper, TextInput, Group, Button } from "@mantine/core"
import { Form } from "@components/forms/Form"
import { useTranslation } from "react-i18next"
import { DefaultBackButton } from "../../-components/Buttons"
import { InfoAlert } from "../../-components/info-alert"
import { GeneratePasswordResetCodeAndSendMailRequest } from "../../@client/Theasoft_ApiServer_Authentication"
import { ErrorText } from "../../blocks/errors/error-alert"
import { usePostMutation } from "../../typed-client/hooks/use-post-mutation"
import { AuthContainer } from "./-components/auth-container"

export const Route = createFileRoute("/authenticate/password-forgotten")({
  component: RouteComponent,
  validateSearch: (search: { userName?: string }) => search,
})

export function RouteComponent() {
  const [activeStep, setActiveStep] = React.useState<0 | 1>(0)
  const requestPasswordResetToken = usePostMutation(
    "/api/Authentication/GeneratePasswordResetTokenAndSendMail",
    {
      onSuccess: () => setActiveStep(1),
    }
  )
  const { userName } = Route.useSearch()
  const { t } = useTranslation("app_server")
  return (
    <AuthContainer
      title={t("ResetPassword")}
      description={
        <Text c="dimmed" size="sm" ta="center" mt={5}>
          {t("Authenticate_PasswordForgotten_Description")}
        </Text>
      }
    >
      <Stepper
        active={activeStep}
        onStepClick={(v) => {
          if (v === 0 || v === 1) {
            setActiveStep(v)
          }
        }}
      >
        <Stepper.Step
          label={t("RequestToken")}
          loading={requestPasswordResetToken.isPending}
        >
          <Form<GeneratePasswordResetCodeAndSendMailRequest>
            onSubmit={async (v) => {
              requestPasswordResetToken.mutate(v)
            }}
            initialValues={{ userNameOrEmail: userName ?? "" }}
          >
            {(f, _) => (
              <>
                <TextInput
                  maxLength={200}
                  label={t("UserNameOrEmail")}
                  placeholder={t("UserNameOrEmailPlaceholder")}
                  autoFocus
                  required
                  {...f.getInputProps(_.userNameOrEmail._PATH_)}
                />

                <Group mt="xl">
                  <DefaultBackButton />
                  <Button
                    disabled={requestPasswordResetToken.isPending}
                    type="submit"
                  >
                    {t("Authenticate_PasswordForgotten_SendLinkButton")}
                  </Button>
                </Group>
                {requestPasswordResetToken.isError ? (
                  <ErrorText mt="xs" error={requestPasswordResetToken.error} />
                ) : null}
              </>
            )}
          </Form>
        </Stepper.Step>
        <Stepper.Completed>
          <InfoAlert title={t("EmailSent")} color="blue">
            {t("Authenticate_PasswordForgotten_InfoAlert")}
          </InfoAlert>
        </Stepper.Completed>
      </Stepper>
    </AuthContainer>
  )
}
